import { create } from 'zustand';

export const usePresenceStore = create((set, get) => ({
  onlineUsers: new Map([
    ['user-1', { id: 'user-1', status: 'online',  lastSeen: Date.now(), activityStartedAt: Date.now() - 420000,
      activity: { type: 'spotify', name: 'Blinding Lights', artist: 'The Weeknd', album: 'After Hours', duration: 200, elapsed: 87, albumArt: null } }],
    ['user-2', { id: 'user-2', status: 'online',  lastSeen: Date.now(), activityStartedAt: Date.now() - 900000,
      activity: { type: 'game', name: 'Minecraft', details: 'Survival Mode', state: 'Building a base', largeIcon: '⛏️' } }],
    ['user-3', { id: 'user-3', status: 'idle',    lastSeen: Date.now() - 600000, activityStartedAt: Date.now() - 300000,
      activity: { type: 'vscode', name: 'Visual Studio Code', details: 'Editing index.ts', state: 'aethex-connect', largeIcon: '💻' } }],
    ['user-4', { id: 'user-4', status: 'dnd',     lastSeen: Date.now(), activityStartedAt: Date.now() - 1800000,
      activity: { type: 'spotify', name: 'Starboy', artist: 'The Weeknd', album: 'Starboy', duration: 230, elapsed: 145, albumArt: null } }],
    ['user-5', { id: 'user-5', status: 'offline', lastSeen: Date.now() - 3600000 }],
  ]),

  typingUsers: new Map(),

  // Current user status
  status: 'online',
  customStatus: '',

  setStatus: (newStatus) => set({ status: newStatus }),

  setCustomStatus: (newCustomStatus) => set({ customStatus: newCustomStatus }),

  // Returns onlineUsers as a plain array — always safe to iterate
  getOnlineUsersArray: () => Array.from(get().onlineUsers.values()),

  setUserPresence: (userId, data) =>
    set((state) => {
      const newMap = new Map(state.onlineUsers);
      const existing = newMap.get(userId) || {};
      newMap.set(userId, { ...existing, id: userId, lastSeen: Date.now(), ...data });
      return { onlineUsers: newMap };
    }),

  setUserStatus: (userId, status) =>
    set((state) => {
      const newMap = new Map(state.onlineUsers);
      const existing = newMap.get(userId) || {};
      newMap.set(userId, { ...existing, id: userId, status, lastSeen: Date.now() });
      return { onlineUsers: newMap };
    }),

  setUserTyping: (channelId, userId, userName) =>
    set((state) => {
      const key = `${channelId}:${userId}`;
      const newMap = new Map(state.typingUsers);
      
      const timeout = setTimeout(() => {
        const updatedMap = new Map(state.typingUsers);
        updatedMap.delete(key);
        set({ typingUsers: updatedMap });
      }, 3000);

      newMap.set(key, { userId, userName, timeout });
      return { typingUsers: newMap };
    }),

  clearUserTyping: (channelId, userId) =>
    set((state) => {
      const key = `${channelId}:${userId}`;
      const newMap = new Map(state.typingUsers);
      const entry = newMap.get(key);
      if (entry) clearTimeout(entry.timeout);
      newMap.delete(key);
      return { typingUsers: newMap };
    }),

  getChannelTypingUsers: (channelId) => {
    const { typingUsers } = get();
    const typingList = [];
    typingUsers.forEach((value, key) => {
      if (key.startsWith(channelId)) {
        typingList.push(value);
      }
    });
    return typingList;
  },

  getUserStatus: (userId) => {
    const { onlineUsers } = get();
    return onlineUsers.get(userId) || { id: userId, status: 'offline', lastSeen: null };
  },
}));
